import { render, staticRenderFns } from "./blog-2.vue?vue&type=template&id=525cffde&scoped=true"
import script from "./blog-2.vue?vue&type=script&lang=js"
export * from "./blog-2.vue?vue&type=script&lang=js"
import style0 from "./blog-2.vue?vue&type=style&index=0&id=525cffde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525cffde",
  null
  
)

export default component.exports